class TeamCtrl {
  constructor($state, $scope, venueService) {
    this._$state = $state;
    this._$scope = $scope;


    venueService.getCurrentVenues()
      .then(results => {
        this.venues = results;
      });
  }

  getPageTitle() {
    if (this._$state.current.name === 'app.organization.team.staff' || this._$state.current.name === 'app.organization.team.staffEdit') return 'Team - Staff';
    if (this._$state.current.name === 'app.organization.team.servers' || this._$state.current.name === 'app.organization.team.serverEdit') return 'Team - Servers';
    if (this._$state.current.name === 'app.organization.team.external' || this._$state.current.name === 'app.organization.team.externalEdit') return 'Team - External';
    return 'Team';
  }

  showBackButton() {
    return this._$state.current.name === 'app.organization.team.staffEdit' ||
      this._$state.current.name === 'app.organization.team.serverEdit' ||
      this._$state.current.name === 'app.organization.team.externalEdit';
  }

  showChangeVenue() {
    return this._$state.current.name === 'app.organization.team.staff' ||
      this._$state.current.name === 'app.organization.team.servers' ||
      this._$state.current.name === 'app.organization.team.external';
  }

  goBack() {
    let state;

    if (this._$state.current.name === 'app.organization.team.staffEdit') {
      state = 'app.organization.settings.staff';
    } else if (this._$state.current.name === 'app.organization.team.serverEdit') {
      state = 'app.organization.settings.servers';
    } else if (this._$state.current.name === 'app.organization.team.externalEdit') {
      state = 'app.organization.settings.promoters';
    }

    return this._$state.go(state);
  }

  changeVenue($event, venue) {
    if ($event) $event.preventDefault();

    this.selectedVenue = venue;
    this._$scope.selectedVenue = venue;
  }

  clearVenue($event) {
    if ($event) $event.preventDefault();

    this.selectedVenue = null;
    this._$scope.selectedVenue = null;
  }
}

TeamCtrl.$inject = [
  '$state',
  '$scope',
  'venueService'
];

export default TeamCtrl;



// WEBPACK FOOTER //
// ./src/components/team/teamCtrl.js